import React, { useContext, useCallback } from "react";
import style from "./Menu.module.css";
import { useHistory } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import ColourContext from "../contexts/ColourContext";
import { colourThemes } from "../styles/colourPalettes";
import logo from "../assets/brand/logo.svg";
import { removeDataInLocalStorage } from "../utils/storage";
import UserContext from "../contexts/UserContext";
import LifeAreasContext from "../contexts/LifeAreasContext";
import ActivityContext from "../contexts/ActivityContext";

type MenuProps = {
  show: boolean;
  closePressed: () => void;
};

const menuContainerVariants = {
  initial: {
    x: "100%",
  },
  visible: {
    x: "0%",
    transition: {
      when: "beforeChildren",
      duration: 0.4,
      staggerChildren: 0.1,
      // ease: "easeIn",
    },
  },
  exit: {
    x: "100%",
    transition: {
      // when: "afterChildren",
      duration: 0.25,
      ease: "easeOut",
    },
  },
};

const menuOptionVariants = {
  initial: {
    opacity: 0,
    x: 32,
  },
  visible: { opacity: 1, x: 0 },
  exit: { opacity: 0 },
};

const Menu = ({ show, closePressed }: MenuProps) => {
  const { key: colourKey, set: setColourKey } = useContext(ColourContext);
  const colour = colourThemes[colourKey];
  // const { user, dispatchUser } = useContext(UserContext);
  const { lifeAreas, dispatchLifeAreas } = useContext(LifeAreasContext);
  const { state: user, dispatch: dispatchUser } = useContext(UserContext);
  const { activity, dispatchActivity } = useContext(ActivityContext);

  const history = useHistory();

  const clearDataPressed = useCallback(() => {
    if (
      window.confirm("Are you sure? There is no way of getting this data back.")
    ) {
      setColourKey("cyan");
      dispatchLifeAreas({ type: "CLEAR_DATA" });
      dispatchUser({ type: "CLEAR_DATA" });
      dispatchActivity({ type: "CLEAR_DATA" });
      closePressed();
      history.push("/welcome");
    }
  }, [history, closePressed]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          className={style.overlay}
          initial={{ opacity: 0 }}
          animate={{ opacity: 0.5 }}
          exit={{ opacity: 0 }}
          onTap={closePressed}
        />
      )}
      {show && (
        <motion.div
          key="menu"
          className={style.container}
          variants={menuContainerVariants}
          style={{ borderLeft: `1px solid ${colour}` }}
          initial="initial"
          animate="visible"
          exit="exit"
        >
          <img src={logo} alt="Fufil" />
          <motion.section
            className={style.option}
            variants={menuOptionVariants}
          >
            <h3>Personal</h3>
            <p>Got an idea or feedback?</p>
            <a href="mailto:hi@matthfrawley.com">
              <button>Contact Developers</button>
            </a>
          </motion.section>

          <motion.section
            className={style.option}
            variants={menuOptionVariants}
          >
            <h3>Buddies</h3>
            <p>Coming soon</p>
          </motion.section>

          <motion.section
            className={style.option}
            variants={menuOptionVariants}
          >
            <h3>Meet</h3>
            <p>Coming soon</p>
          </motion.section>

          <motion.section variants={menuOptionVariants}>
            {/* <button>Install App</button> */}
            <button
              onClick={clearDataPressed}
              style={{ color: "#C90071", borderColor: "#C90071" }}
            >
              Clear Data
            </button>
          </motion.section>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Menu;
